import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { IPC_CHANNEL, STANDALONE } from '../../_offline/electron.constants';
import { IndividualReportTemplateSchema } from '../../_offline/models/individual-report-template.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class IndividualReportTemplateDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  putAll(reportTemplates: IndividualReportTemplateSchema[]): Observable<IndividualReportTemplateSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.PUT_ALL, reportTemplates);
  }

  put(reportTemplate: IndividualReportTemplateSchema): Observable<IndividualReportTemplateSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.PUT_ONE, reportTemplate)
      .pipe(
        map(x => x as IndividualReportTemplateSchema)
      );
  }

  getAll(subjectModelId: string, isAliveOnly = true): Observable<IndividualReportTemplateSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.GET_ALL, subjectModelId, this.tenantId, isAliveOnly);
  }

  getAllOnPremise(subjectModelId: string, isAliveOnly = true): Observable<IndividualReportTemplateSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.GET_ALL, subjectModelId, STANDALONE.TENANT_ID, isAliveOnly);
  }

  get(id: string): Observable<IndividualReportTemplateSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.GET_ONE, id, this.tenantId);
  }

  /**
   * レポートテンプレートを削除する。
   *
   * @param reportTemplateId レポートテンプレート ID。
   * @param userId 実行したユーザーの ID。
   * @param templateDirectoryPath テンプレート画像のディレクトリーのパス。
   * @param isLogicalDelete true … 論理削除する。
   * @returns 成功した場合は true を返す。
   */
  public delete(reportTemplateId: string, userId: string, templateDirectoryPath: string, isLogicalDelete: boolean = true): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.DELETE, reportTemplateId, userId, templateDirectoryPath, isLogicalDelete)
      .pipe(
        map(x => x as boolean)
      );
  }

  hasReports(reportTemplateId: string): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.INDIVIDUAL_REPORT_TEMPLATE.HAS_REPORTS, reportTemplateId);
  }

}
